// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__zvVCj","heroBtnPrimary":"Hero_heroBtnPrimary__LCfIz"};